import {
  IonIcon, IonImg, IonPage, IonText,
} from '@ionic/react';
import parse from 'html-react-parser';
import { chevronBackOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import { ArticleResponse } from '@/interfaces/LearningInterface/LearningInterface';

import styles from './ArticleDetail.module.scss';

export default function ArticleDetail() {
  const history = useHistory();
  const location = useLocation();
  const articleContentRef = useRef<HTMLDivElement>(null);

  const [article, setarticle] = useState<ArticleResponse>(
    location.state as ArticleResponse,
  );
  const [articleList, setarticleList] = useState<ArticleResponse[]>([]);
  const isTablet = useMediaQuery(Breakpoint.Tablet);
  const isDesktop = useMediaQuery(Breakpoint.Tablet);

  const [isMobile, setIsMobile] = useState(!isTablet && !isDesktop);

  useEffect(() => {
    setIsMobile(!isTablet && !isDesktop);
  }, [isTablet, isDesktop]);

  const getArticlesFromApi = async () => {
    try {
      const response = await fetch(
        'https://pepperfinance.es/wp-json/wp/v2/posts/?per_page=6&categories=29&orderby=modified&order=desc',
      );
      const responseJson = await response.json();
      setarticleList(responseJson);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      setarticle(location.state as ArticleResponse);
      if (articleContentRef.current) {
        articleContentRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);

  useEffect(() => {
    getArticlesFromApi();
  }, []);

  const handleViewAll = (route: ROUTES_PATH) => {
    if (isMobile) {
      return history.push(ROUTES_PATH.ALL_RESOURCES_MOBILE, { route });
    }
    history.push(route);
  };

  return (
    <IonPage>
      <div className={styles.articlePage}>
        <div className={styles.titleWrapper}>
          <Link className={styles.backBtn} to={ROUTES_PATH.LEARNING}>
            <IonIcon slot="start" icon={chevronBackOutline} />
            <span className={styles.fullText}>Volver a artículos</span>
            <span className={styles.shortText}>Volver</span>
          </Link>
        </div>
        <div className={styles.articleContent} ref={articleContentRef}>
          <div className={styles.mainContent}>
            <IonImg src={article?.fimg_url} className={styles.mainImg} />
            <div className={styles.textContent}>
              <IonText className={styles.titleText}>
                {article?.title?.rendered}
              </IonText>
              <IonText className={styles.contentText}>
                {parse(article?.content?.rendered || '')}
              </IonText>
            </div>
          </div>
          <div className={styles.articleList}>
            <div className={styles.listHeader}>
              <IonText className={styles.otherArtTitle}>Otros artículos</IonText>
              <div onClick={() => handleViewAll(ROUTES_PATH.ARTICLE_ALL)} className={styles.seeAll}>
                Ver todos
              </div>
            </div>
            <div className={styles.otherArticlesContent}>
              {articleList.map((articleItem: ArticleResponse, index) => {
                if (article.id !== articleItem?.id) {
                  return (
                    <Link
                      to={{
                        pathname:
                          `${ROUTES_PATH.ARTICLE_DETAIL}/${articleItem?.id}`,
                        state: articleItem,
                      }}
                      className={styles.otherArticlesWrapper}
                      key={index}
                    >
                      <IonImg src={articleItem?.fimg_url} className={styles.artImg} />
                      <div className={styles.artText}>
                        <IonText className={styles.titleText}>
                          {articleItem?.title?.rendered}
                        </IonText>
                      </div>
                    </Link>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
}
